import { fetchAuthSession, getCurrentUser } from "@aws-amplify/auth";
import { useEffect, useState } from "react";

export function useAuthentication() {
  const [userId, setUserId] = useState(null);
  const [isMaster, setIsMaster] = useState(false);

  useEffect(() => {
    getCurrentUser()
      .then((user) => {
        setUserId(user.userId);
      })
      .catch(() => {
        setUserId(undefined);
      });
    fetchAuthSession()
      .then((session) => {
        setIsMaster(
          session.tokens.idToken.payload["cognito:groups"].includes("master")
        );
      })
      .catch(() => {
        setIsMaster(false);
      });
  }, []);

  return {
    userId,
    isMaster,
  };
}
